export class FetchError extends Error {
  status: number | undefined
  statusText: string | undefined
  constructor(message?: string, options?: ErrorOptions, status?: number, statusText?: string) {
    super(message, options)
    this.status = status
    this.statusText = statusText
  }
}
